module.exports = __webpack_public_path__ + "media/images/pages/solutions/automation/survey_flow_traditional-cd372b4e0aa382a8cf5214491d509dff.png";